module.exports = __webpack_public_path__ + "img/map-hours-table-chevy.cdb07c79.png";